import axios from "axios";

export const api = axios.create({
  baseURL: "/api",       // 🔥 теперь просто относительный путь
  withCredentials: false,
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const msg = err?.response?.data?.detail || err.message;
    return Promise.reject(new Error(msg));
  }
);

export default api;
